module.exports = __webpack_public_path__ + "img/red-right.904133dd.png";